import { render } from "./AddReabonnementPage.vue?vue&type=template&id=45966144&ts=true"
import script from "./AddReabonnementPage.vue?vue&type=script&lang=ts"
export * from "./AddReabonnementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__